// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof')
  , from    = require('./_array-from-iterable');
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_collection-to-json.js
 ** module id = 506
 ** module chunks = 2 4 6 8 9 11 12
 **/